<template>
	<div class="result-card" @click="goTo">
		<div class="result-card__path">
			<SearchResultPath :article="result" :showTitle="true" />
		</div>
		<div class="result-card__content">
			<SearchResultHighlight
				:textToHighlight="textToShow"
				:searchPhrase="searchString"
			/>
		</div>
		<div class="result-card__arrow"></div>
	</div>
</template>

<script>
import SearchResultPath from "./SearchResultPath";
import SearchResultHighlight from "./SearchResultHighlight";

export default {
	name: "SearchResultsCard",
	props: ["result", "searchString"],
	components: {
		SearchResultPath,
		SearchResultHighlight,
	},
	methods: {
		goTo: function () {
			this.$router.push({
				path: "article-view",
				query: { id: this.result.id },
			});
		},
		getFirstMatchHeading: function (html, search) {
			if (!search || !html) return;

			let h2RegExp = /<h2 [^>]+>.*?<\/h2>/;
			let h3RegExp = /<h3 [^>]+>.*?<\/h3>/;
			let hasMatches = true;
			let heading;

			while (hasMatches) {
				let matchh2 = h2RegExp.exec(html);
				let matchh3 = h3RegExp.exec(html);

				if (matchh2 && matchh2[0]) {
					if (
						matchh2[0].toLowerCase().includes(search.toLowerCase())
					) {
						heading = matchh2[0];
						break;
					}
					html = html.replace(h2RegExp, `[[***h2***]]`);
				}

				if (matchh3 && matchh3[0]) {
					if (
						matchh3[0].toLowerCase().includes(search.toLowerCase())
					) {
						heading = matchh3[0];
						break;
					}
					html = html.replace(h3RegExp, `[[***h3***]]`);
				}

				hasMatches = h2RegExp.test(html) || h3RegExp.test(html);
			}

			return heading;
		},
		getFirstMatchParagraph: function (html, search) {
			if (!search || !html) return;

			let regExp = /<p>.*?<\/p>/;
			let hasMatches = true;
			let paragraph;

			while (hasMatches) {
				let match = regExp.exec(html);

				if (match && match[0]) {
					if (
						match[0].toLowerCase().includes(search.toLowerCase()) &&
						!match[0].toLowerCase().includes('<img')
					) {
						paragraph = match[0];
						break;
					}
					html = html.replace(regExp, `[[***pp***]]`);
				}

				hasMatches = regExp.test(html);
			}

			return paragraph;
		},
	},
	computed: {
		textToShow: function () {
			let heading = this.getFirstMatchHeading(
				this.result.html,
				this.searchString
			);
			let paragraph = this.getFirstMatchParagraph(
				this.result.html,
				this.searchString
			);
			let text = (heading || "") + (paragraph || "");
			return text;
		},
	},
};
</script>

<style scoped>

	.result-card {
		position: relative;
		width: 100%;
		border: 2px solid var(--clr-neutral-shade-3);
		border-radius: 0.3em;
		padding: 1em 1.2em;
		margin-bottom: 1em;
		cursor: pointer;
		transition: 
			border-color 0.3s ease-in-out,
			background-color 0.3s ease-in-out
		;
	}

	.result-card:hover {
		cursor: pointer;
		border-color: var(--clr-accent-primary);
		background-color: hsl(from var(--clr-accent-primary) h s 96% );
	}

	.result-card__path {
		padding-bottom: 0.5em;
	}

	.result-card__arrow {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 2rem;
		height: 2rem;
		display: flex;
		align-items: center;
		justify-self: center;
		opacity: 0.5;
	}

	.result-card:hover .result-card__arrow {
		color: var(--clr-accent-primary);
	}

	.result-card__arrow::before {
		display: block;
		font-family: "Font Awesome 6 Pro";
		content: '\f105';
	}

</style>